export default __webpack_public_path__ + "static/media/share.c3997ab5.svg";